import React from 'react'
import withStyles from 'constructicon/with-styles'
import styles from './styles'
import Button from '../Button'

const Banner = ({
  childStickers = [],
  classNames,
  bannerUrlCta,
  styles
}) => (
  <div className={classNames.root}>
    {childStickers.map(childSticker => (
      childSticker.banner_x_percent
        ? (
          <img
            alt={childSticker.sticker.name}
            className={classNames.sticker}
            key={childSticker.id}
            src={childSticker.sticker.image_url}
            style={{
              top: `${childSticker.banner_y_percent}%`,
              left: `${childSticker.banner_x_percent}%`
            }}
          />
          )
        : null
    ))}
    {bannerUrlCta && (
      <Button
        tag='a'
        href={bannerUrlCta}
        target='_blank'
        rel='noopener noreferrer'
        theme='lightPrimary'
        size={-0.5}
        styles={styles.bannerCTA}
      >
        <span>
          CLICK<br />HERE
        </span>
      </Button>
    )}
  </div>
)

export default withStyles(styles)(Banner)
